import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { portfolio }: Boundaries["removeProjectPortfolio"]["request"],
): State {
  const index = state.findIndex((req) => req.portfolio.uuid === portfolio.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { portfolio, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { portfolio, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { portfolio }: Boundaries["removeProjectPortfolio"]["success"],
): State {
  const index = state.findIndex((req) => req.portfolio.uuid === portfolio.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { portfolio, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { portfolio, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  { portfolio }: Boundaries["removeProjectPortfolio"]["failure"],
): State {
  const index = state.findIndex((req) => req.portfolio.uuid === portfolio.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { portfolio, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { portfolio, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeProjectPortfolioRequested]: handleRequest,
    [events.removeProjectPortfolioSucceeded]: handleSuccess,
    [events.removeProjectPortfolioFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
